<section class="projects-section">
    <div class="container">
        <h1><i class="fa-solid fa-diagram-project"></i> Project Management</h1>
        <div *ngFor="let n of socket.notifications$ | async">
            <div class="card">
                <b>{{ n.title }}</b>
                <p>{{ n.message }}</p>
                <small>{{ n.timestamp }}</small>
            </div>
        </div>


        <div class="card">
            <div class="page-header">
                <h3 class="page-title">Projects</h3>
                <div class="flex-spacer"></div>

                <button routerLink="/create-project" class="icon-btn create">
                    <i class="fa-solid fa-plus"></i>
                </button>
            </div>

            <div class="table-wrapper table-mobile-card">


                <table class="table" id="projects-table">
                    <thead>
                        <tr>
                            <th resizableColumn tableId="projects-table" colKey="domain">
                                Domain
                            </th>

                            <th resizableColumn tableId="projects-table" colKey="description">
                                Description
                            </th>

                            <th resizableColumn tableId="projects-table" colKey="status" class="status-col">
                                Status
                            </th>

                            <th resizableColumn tableId="projects-table" colKey="creation" class="date-col">
                                Creation Date
                            </th>

                            <th resizableColumn tableId="projects-table" colKey="actions" class="action-col">
                                View
                            </th>
                        </tr>
                    </thead>

                    <tbody>

                        <!-- EMPTY STATE -->
                        <tr *ngIf="projects.length === 0">
                            <td colspan="100%">
                                <div class="no-data">
                                    <i class="fa-regular fa-folder-open"></i>
                                    No items found
                                </div>
                            </td>
                        </tr>

                        <!-- DATA ROWS -->
                        <tr *ngFor="let p of projects">

                            <td data-label="Domain">
                                {{ p.domain }}
                            </td>

                            <td data-label="Description">
                                {{ p.description }}
                            </td>

                            <td data-label="Status">
                                <span [ngClass]="p.active ? 'status-active' : 'status-disabled'">
                                    {{ p.active ? 'Active' : 'Disabled' }}
                                </span>
                            </td>

                            <td data-label="Creation Date" class="date-col">
                                {{ p.creationDate.split('T')[0] }}
                            </td>

                            <td data-label="Actions" class="action">
                                <button class="icon-btn roles" data-tip="Roles" (click)="openProjectRoles(p.projectId)">
                                    <i class="fa-solid fa-shield-halved"></i>
                                </button>

                                <button class="icon-btn users" data-tip="Users" (click)="openProjectUsers(p.projectId)">
                                    <i class="fa-solid fa-users"></i>
                                </button>

                                <button class="icon-btn settings" data-tip="Settings"
                                    (click)="viewProject(p.projectId)">
                                    <i class="fa-solid fa-gear"></i>
                                </button>

                            </td>
                        </tr>

                    </tbody>
                </table>

                <!-- GLOBAL PAGINATION -->
                <div class="pagination-bar">
                    <div class="left">
                        <label>Page Size : </label>
                        <select [(ngModel)]="size" (change)="changeSize()">
                            <option [value]="10">10</option>
                            <option [value]="15">15</option>
                            <option [value]="25">25</option>
                            <option [value]="50">50</option>
                        </select>
                    </div>

                    <div class="center">
                        Page {{ page + 1 }} / {{ totalPages }}
                    </div>

                    <div class="right">
                        <button class="btn-page" (click)="prevPage()" [disabled]="page === 0">←</button>

                        <button class="btn-page" (click)="nextPage()" [disabled]="page >= totalPages - 1">→</button>
                    </div>
                </div>

            </div>

        </div>

    </div>
</section>